"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRK_PRODUCT_LOCATION = exports.RECOMPUTE_DELAY = exports.MORE_DETAILS = exports.ENTER_KEY = exports.COLLAPSED_HEIGHT_OPTIONS = exports.ALIGNMENTS = void 0;
var TRK_PRODUCT_LOCATION = 'ExpandableContent';
exports.TRK_PRODUCT_LOCATION = TRK_PRODUCT_LOCATION;
var RECOMPUTE_DELAY = 250; // ms
exports.RECOMPUTE_DELAY = RECOMPUTE_DELAY;
var ENTER_KEY = 13;

/**
 * Keep in sync with definition in `./expandable-content.module.less`
 */
exports.ENTER_KEY = ENTER_KEY;
var COLLAPSED_HEIGHT_OPTIONS = {
  DRIVER_TITLE_HEIGHT: 'DRIVER_TITLE_HEIGHT',
  FOUR_LINES_HEIGHT: 'FOUR_LINES_HEIGHT'
};

/**
 * Text alignment constants.
 */
exports.COLLAPSED_HEIGHT_OPTIONS = COLLAPSED_HEIGHT_OPTIONS;
var ALIGNMENTS = {
  LEFT: 'left',
  CENTER: 'center'
};

/**
 * Analytics entity name
 */
exports.ALIGNMENTS = ALIGNMENTS;
var MORE_DETAILS = 'expandable_content';
exports.MORE_DETAILS = MORE_DETAILS;